export { SidebarFooter as SidebarV2Footer } from './SidebarFooter';
export { SidebarFooterContent as SidebarV2FooterContent } from './SidebarFooterContent';
